import { gql } from "@apollo/client";

export const ADD_ANSWER = gql`
  mutation addAnswer(
    $answer: String!
    $questionId: uuid!
    $optionId: uuid
    $userId: uuid
    $createdAt: timestamptz
  ) {
    insert_answer(
      objects: [
        {
          answer: $answer
          question_id: $questionId
          option_id: $optionId
          user_id: $userId
          created_at: $createdAt
        }
      ]
      on_conflict: { constraint: answer_pkey, update_columns: [] }
    ) {
      affected_rows
      returning {
        answer_id
      }
    }
  }
`;

export const UPDATE_ANSWER = gql`
  mutation updateAnswer($id: uuid!, $answer: answer_set_input!) {
    update_answer(where: { answer_id: { _eq: $id } }, _set: $answer) {
      affected_rows
    }
  }
`;

export const DELETE_ANSWER = gql`
  mutation deleteAnswer($id: uuid!) {
    delete_answer(where: { answer_id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
